<template>
    <load v-if="loading" message="Carregando Midia" />
    <div v-else class="row">
    Edit</div>
</template>
<script>

export default {
    props: [],
    components: {  },
    name: "Edit",
    data() {
        return {
        loading:false
            };
    },
    mounted() {
      
    },
    methods: {
        
    },
};
</script>